import angular from 'angular';
import { ToggleComponent } from './toggle.ng1.component';

const ToggleModule = angular
    .module('control-room.commons.form.components.toggle', [])
    .component('crToggle', ToggleComponent);

export default ToggleModule;
